export default __webpack_public_path__ + "static/media/GustavDustParticleFrontRight.6b121aef.png";